import React, { useContext, useEffect, useState, useRef } from 'react'
// import InputSelect from '../CustomInput/InputSelect'
import myContext from '../../FiltersComponent/context/context'
import { isFilterApplied } from '../../Utility/Utility.js'
// import { AuthContext } from '../../../../context/AuthContext'
import { loadOVSearchCriteria, loadSearchCriteria } from '../../Utility/LoadSavedSearch/LoadSavedSearch'
import ApplyFilters from '../../FiltersComponent/ApplyFilters/ApplyFilters'
// import { Equalizer, TrendingUp, Explore } from '@material-ui/icons'

const SelectSearchType = () => {

  const { preSearchCriteria, setPreSearchCriteria, savedSearch, searchCriteria,
    setSearchFields, setSearchCriteria, setShowSpinner, setalertProps, setShowAlert } = useContext(myContext)
  // const keycloak = useContext(AuthContext)
  const [criteriaProcessed, setCriteriaProcessed] = useState(false)
  const ApplyFiltersRef = useRef()

  // const searchTypeOptions = [
  //   {
  //     value: 'rent',
  //     label: 'Rent comps'
  //   },
  //   {
  //     value: 'sales',
  //     label: 'Sales comps'
  //   },
  //   {
  //     value: 'prospecting',
  //     label: 'Prospecting'
  //   }
  // ]

  useEffect(() => {

    if (preSearchCriteria.searchType === 'prospecting') {
      loadTargetMarket()
    }

  }, [preSearchCriteria])

  useEffect(() => {

    if (criteriaProcessed) {
      setCriteriaProcessed(false)
      ApplyFiltersRef.current.callhandleClick()
    }

  }, [criteriaProcessed])

  // const handleChange = event => {
  //   setPreSearchCriteria({ ...preSearchCriteria, searchType: event.target.value })
  // }

  const loadTargetMarket = () => {
    if (!isFilterApplied(searchCriteria)) {
      const index = savedSearch.findIndex(x => x.isTargetMarket)
      if (index !== -1) {

        if (!savedSearch[index].polarisSearchCriteria && !savedSearch[index].omniViewSearchCriteria) {
          setalertProps({ message: 'This Saved Search cannot be used, please create a new Saved Search!! ', type: 'error' })
          setShowAlert(true)
          return
        }

        if (savedSearch[index].polarisSearchCriteria && savedSearch[index].polarisSearchCriteria !== '') {
          loadSearchCriteria(savedSearch[index].polarisSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
        } else {
          setShowSpinner(true)
          loadOVSearchCriteria(savedSearch[index].omniViewSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
        }
        // if (savedSearch[index].omniViewSearchCriteria && savedSearch[index].omniViewSearchCriteria !== '') {
        //   setShowSpinner(true)
        //   loadOVSearchCriteria(savedSearch[index].omniViewSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
        // } else {
        //   loadSearchCriteria(savedSearch[index].polarisSearchCriteria, setSearchFields, setSearchCriteria, setCriteriaProcessed)
        // }
      }
    }
  }

  const handleTabChange = newTab => {
    setPreSearchCriteria({ ...preSearchCriteria, searchType: newTab })
  }

  return (
    <>
      <div className="m-2 text-base items-center grid grid-cols-3 border-base border-1 rounded-pill">

        <div data-testid="test-Search-type-rent" onClick={() => handleTabChange('rent')} className={`rounded-l-pill p-2 pl-4 ${preSearchCriteria.searchType === 'rent' ? 'bg-gray-15' : ''}`} >
          <input className="mt-3" type="radio" id="searchTypeRent" name="searchType" value="rent"
            checked={preSearchCriteria.searchType === 'rent' ? true : false} />
          <label for="searchTypeRent" className="pl-3 text-2">Rent</label>
        </div>

        <div onClick={() => handleTabChange('sales')} className={`p-2 pl-3 border-l-1 border-r-1 border-base ${preSearchCriteria.searchType === 'sales' ? 'bg-gray-15' : ''}`} >
          <input className="mt-3" type="radio" id="searchTypeSales" name="searchType" value="sales"
            checked={preSearchCriteria.searchType === 'sales' ? true : false} />
          <label for="searchTypeSales" className="pl-3 text-2" >Sales</label>
        </div>

        <div data-testid="test-Search-type-prospecting" onClick={() => handleTabChange('prospecting')} className={`rounded-r-pill p-2 pl-3 ${preSearchCriteria.searchType === 'prospecting' ? 'bg-gray-15' : ''}`} >
          <input className="mt-3" type="radio" id="searchTypeProspect" name="searchType" value="prospecting"
            checked={preSearchCriteria.searchType === 'prospecting' ? true : false} />
          <label for="searchTypeProspect" className="pl-2 text-2">Prospect</label>
        </div>

      </div>
      {/* <nav className="flex flex-row text-2">
        <button data-testid="test-Search-type-rent" onClick={() => handleTabChange('rent')} className={`btn px-6 ${preSearchCriteria.searchType === 'rent' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
          <span className="pr-2"> <Equalizer fontSize="small"></Equalizer> </span>
          Rent comps
          </button>
        <button onClick={() => handleTabChange('sales')} className={`btn px-6 ${preSearchCriteria.searchType === 'sales' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
          <span className="pr-2"> <TrendingUp fontSize="small"></TrendingUp> </span>
          Sales comps
        </button>
        <button data-testid="test-Search-type-prospecting" onClick={() => handleTabChange('prospecting')} className={`btn px-6 ${preSearchCriteria.searchType === 'prospecting' ? 'text-primary bg-gray-15 border-b-1 border-l-0 border-r-0 border-t-0 border-primary' : 'bg-white'} `}>
          <span className="pr-2"> <Explore fontSize="small"></Explore> </span>
          Prospecting
        </button>
      </nav> */}
      {/* <div className="form-control:none inline-block relative mr-3">
        <InputSelect optionsList={searchTypeOptions} testid={'test-Search-type-ddl'} onChange={handleChange} id="selctType" value={preSearchCriteria.searchType} classes={'w-full border-none'}></InputSelect>
      </div> */}
      <div className="hidden">
        <ApplyFilters ref={ApplyFiltersRef} handleClose={() => { }} criteriaToApply="all"></ApplyFilters>
      </div>
    </>
  )
}

export default SelectSearchType
